/**
 * Bounds for the public opportunity list.
 *
 * A dependency-free LEAF module, like `../../routers/external/v2/limits`: the
 * marketing page is a client component, so anything it imports must not pull in
 * the @repo/api root index's server-only DB chain.
 *
 * The page asks for the ceiling because it renders every open listing in one
 * pass; the router validates against the same constant, so the request it sends
 * cannot become one the schema rejects.
 */

/**
 * Maximum listings `listPublicListings` will return, and what the marketing
 * page requests. Headroom over the current open-listing count, not a target:
 * growing past it is a pagination decision, not a bigger number here.
 */
export const PUBLIC_LISTINGS_MAX_LIMIT = 200;

/**
 * Maximum studies one advertised-rate read answers for.
 *
 * Sized for the largest page of cards that exists rather than for any one
 * caller: the marketing listing page renders every open listing in one pass.
 * A caller past the ceiling gets no figure for the tail.
 */
export const ADVERTISED_RATES_MAX_STUDY_IDS = 200;
